"use strict";

const { String } = require("../lib/types");

const resuscitation = "Does the patient wish to attempt resuscitation?";
const resuscitationDocumentation =
  "Does the patient have documentation supporting this decision?";

module.exports = {
  resuscitation: {
    name: "resuscitation",
    question: resuscitation,
    fhirType: String,
    jq: ["item[text=?].answer[0].valueString", resuscitation]
  },
  resuscitationDocumentation: {
    name: "resuscitationDocumentation",
    question: resuscitationDocumentation,
    fhirType: String,
    jq: ["item[text=?].answer[0].valueString", resuscitationDocumentation]
  }
};
